module.exports = __webpack_public_path__ + "img/40_69_009_730.cdd9172c.jpg";